module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/bg_whale_shark-f75e4a940767bcf847d5142f55a779b5.png";